<div class="relative w-full select-none">

	@if (!sales().length) {
		<div class="flex flex-col items-center justify-center gap-2 py-10 border border-dashed border-peps-dark-500">
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="size-8 text-peps-dark-200/20">
				<path stroke-linecap="round" stroke-linejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" />
			</svg>
			<span class="text-sm uppercase font-dinpro-medium tracking-wider text-peps-dark-200/40">{{ 'page.marketplace.detail.no-sales' | translate }}</span>
		</div>
	} @else {
		<svg
			#svg
			[attr.viewBox]="viewBox"
			preserveAspectRatio="xMidYMid meet"
			class="w-full h-auto block"
			role="img"
			[attr.aria-label]="ariaSummary()"
			(mousemove)="onMouseMove($event)"
			(mouseleave)="onMouseLeave()"
		>
			<defs>
				<linearGradient id="priceAreaGradient" x1="0" y1="0" x2="0" y2="1">
					<stop offset="0%" stop-color="#EEC932" stop-opacity="0.25" />
					<stop offset="100%" stop-color="#EEC932" stop-opacity="0" />
				</linearGradient>
			</defs>

			<!-- Grille -->
			@for (line of gridLines(); track line.y) {
				<line [attr.x1]="plotLeft" [attr.x2]="plotRight" [attr.y1]="line.y" [attr.y2]="line.y" stroke="rgba(255,255,255,0.07)" stroke-width="1" />
				<text [attr.x]="plotLeft - 8" [attr.y]="line.y + 6" text-anchor="end" class="fill-peps-dark-200/50" font-size="18">{{ line.price }}</text>
			}

			<!-- Aire sous la courbe -->
			<path [attr.d]="areaPath()" fill="url(#priceAreaGradient)" />

			<!-- Ligne de prix -->
			<path [attr.d]="linePath()" fill="none" stroke="#EEC932" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />

			<!-- Crosshair -->
			@if (hoverPoint(); as hp) {
				<line [attr.x1]="hp.x" [attr.x2]="hp.x" [attr.y1]="plotTop" [attr.y2]="baseY" stroke="rgba(255,255,255,0.15)" stroke-width="1" stroke-dasharray="3 3" />
			}

			<!-- Points (cercle visible + zone de survol élargie) -->
			@for (p of points(); track $index) {
				<circle [attr.cx]="p.x" [attr.cy]="p.y" r="9" fill="transparent" />
				<circle
					[attr.cx]="p.x"
					[attr.cy]="p.y"
					[attr.r]="hoverIndex() === $index ? 5 : 3"
					fill="#EEC932"
					[attr.stroke]="hoverIndex() === $index ? '#0a0a0f' : 'none'"
					stroke-width="2"
				/>
			}

			<!-- Dates première / dernière vente -->
			@if (points().length) {
				<text [attr.x]="points()[0].x" [attr.y]="baseY + 26" text-anchor="start" class="fill-peps-dark-200/50" font-size="17">
					{{ points()[0].sale.soldAt | localizedDate:'d MMM' }}
				</text>
				@if (points().length > 1) {
					<text [attr.x]="points()[points().length - 1].x" [attr.y]="baseY + 26" text-anchor="end" class="fill-peps-dark-200/50" font-size="17">
						{{ points()[points().length - 1].sale.soldAt | localizedDate:'d MMM' }}
					</text>
				}
			}
		</svg>

		@if (hoverPoint(); as hp) {
			<div
				class="absolute z-10 pointer-events-none -translate-x-1/2 -translate-y-[calc(100%+10px)] bg-peps-dark-900 border border-peps-gold/30 px-3 py-2 whitespace-nowrap shadow-lg"
				[style.left.%]="pointLeftPct(hp)"
				[style.top.%]="pointTopPct(hp)"
			>
				<div class="text-lg font-dinpro-bold text-peps-gold leading-tight">{{ hp.sale.price }} PepsCoins</div>
				<div class="text-sm uppercase text-peps-dark-200/60 leading-tight">{{ hp.sale.soldAt | localizedDate:'d MMM yyyy · HH:mm' }}</div>
			</div>
		}
	}

</div>
